import { gql } from '@apollo/client';

export const UPDATE_GROUP = gql`
	mutation updateGroup($name: String!, $id: ID!, $description: String) {
		updateCrewMemberGroup(name: $name, id: $id, description: $description) {
			... on CrewMemberGroupSuccessResponse {
				group {
					id
					name
					description
					createdBy
					membersCount
				}
			}
			... on CrewMemberGroupErrorResponse {
				errors
			}
		}
	}
`;
